import {ProductCost} from './ProductCost';
import {TotalCost} from './TotalCost';
import {Product} from './Product';
import {StockAmountAlert} from './OrderItemProduct';

export class OrderItemProductPackageProduct {
  public id: number;
  public product: Product | number ;
  public productObj: Product;
  public cost = new ProductCost();
  public totalCost = new TotalCost();
  public stockAmountAlert?: StockAmountAlert = new StockAmountAlert();
}
